var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamHoverVoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Team",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6211",
    "data-name": "Rectangle 6211",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_40",
    "data-name": "Union 40",
    d: "M5.686,10.446V7.05A1.325,1.325,0,0,1,7,5.721h4.62A1.326,1.326,0,0,1,12.945,7.05v3.4a3.629,3.629,0,1,1-7.258,0ZM6.9,7.05v3.4a2.42,2.42,0,0,0,.7,1.717,2.415,2.415,0,0,0,3.417,0,2.42,2.42,0,0,0,.7-1.717V7.05a.1.1,0,0,0-.1-.1H7A.1.1,0,0,0,6.9,7.05ZM0,10.446V7.05A1.325,1.325,0,0,1,1.319,5.721H5.66l-.1.128a1.883,1.883,0,0,0-.421,1.03l-.006.07H1.319a.1.1,0,0,0-.1.1v3.4a2.422,2.422,0,0,0,2.413,2.426,2.381,2.381,0,0,0,1.735-.745l.077-.08.045.1a4.227,4.227,0,0,0,.555.92l.046.059-.055.05A3.619,3.619,0,0,1,0,10.446ZM6.752,2.58A2.563,2.563,0,1,1,9.315,5.16,2.574,2.574,0,0,1,6.752,2.58Zm1.216,0a1.346,1.346,0,1,0,2.692,0,1.346,1.346,0,1,0-2.692,0Zm-6.9,0A2.563,2.563,0,1,1,3.629,5.16,2.574,2.574,0,0,1,1.066,2.58Zm1.216,0a1.346,1.346,0,1,0,2.692,0,1.346,1.346,0,1,0-2.692,0Z",
    transform: "translate(1.527 0.949)",
    fill: "#fd581f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamHoverVoice);
export default __webpack_public_path__ + "static/media/TeamHover-voice.9f9d54ae13e583e4c47ba9bf16d0d608.svg";
export { ForwardRef as ReactComponent };